import { REDIRECT_HOSTS } from './constants';

type RedirectEnvironment = keyof typeof REDIRECT_HOSTS;

type RedirectLocation = Pick<Location, 'hostname' | 'protocol' | 'port'>;

const getRedirectEnvironment = (hostname: string): RedirectEnvironment => {
  if (hostname.endsWith('.local')) {
    return 'test';
  }
  if (hostname.includes('stage.')) {
    return 'stage';
  }
  return 'production';
};

/**
 * Build the homepage URL of a market's dedicated site, deriving the environment
 * from the current hostname and preserving its scheme and port, e.g.
 * `https://www.carigami.fr/`.
 */
export const getMarketRedirectUrl = (
  market: string,
  { hostname, protocol, port }: RedirectLocation,
) => {
  const host = REDIRECT_HOSTS[getRedirectEnvironment(hostname)][market];
  const portSuffix = port ? `:${port}` : '';
  return `${protocol}//${host}${portSuffix}/`;
};
